import { type FC } from 'react';
import { _isNil, _notNil } from '@/littledash';
import { type TreatmentGroup } from '@/model/TreatmentGroup.model';
import { ModalActions, ModalContainer, ModalHeader, useModalAction } from '@/utils/modal';
import { RiSquareFill } from 'react-icons/ri';

interface SampleNamesGroupInfoProps {
  groupNumbers: Array<number>;
  groupByNumberMap: Record<number, TreatmentGroup>;
  plannedAnimals: Record<string, number>;
  animalCountByGroup: Record<string, number>;
}

export const SampleNamesGroupInfo: FC<SampleNamesGroupInfoProps> = ({
  groupNumbers,
  groupByNumberMap,
  plannedAnimals,
  animalCountByGroup,
}) => {
  const { closeModal } = useModalAction();

  return (
    <ModalContainer size="xnarrow">
      <ModalHeader title="Study Groups" closeModal={closeModal} />
      <div className="overflow-y-auto" style={{ maxHeight: '70vh' }}>
        {groupNumbers.map((no) => {
          const group = groupByNumberMap[no];
          if (_isNil(group)) {
            return null;
          }
          const planned = _notNil(group.api_id) ? (plannedAnimals[group.api_id] ?? 0) : 0;
          const animals = _notNil(group.api_id) ? (animalCountByGroup[group.api_id] ?? 0) : 0;
          return (
            <div key={no} className="pa3 bb b--moon-gray">
              <div className="flex flex-row items-center gap-h-1 mb2 near-black">
                {_notNil(group.no) && <span>{`${group.no} - `}</span>}
                {_notNil(group.color) && <RiSquareFill color={group.color} />}
                <span>{group.name ?? String(group.no)}</span>
              </div>
              <div className="f6">
                <div className="flex justify-between pv1">
                  <span className="mid-gray">Capacity:</span>
                  <span>{group.max_subjects}</span>
                </div>
                <div className="flex justify-between pv1">
                  <span className="mid-gray">Planned animals:</span>
                  <span>{planned}</span>
                </div>
                <div className="flex justify-between pv1">
                  <span className="mid-gray">Animals:</span>
                  <span>{animals}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="pa3">
        <ModalActions onCancel={closeModal} cancelBtnText="Close" />
      </div>
    </ModalContainer>
  );
};
